import { marked } from "marked";

marked.use({ breaks: true, gfm: true });

export function formatText(str: string) {
  if (!str) {
    return "";
  }

  return marked.parse(str) as string;
}

export function prettifyUrl(url: string) {
  if (!url) {
    return "";
  }

  const normalizedUrl = url.trim();

  try {
    const parsedUrl = new URL(normalizedUrl);

    return parsedUrl.hostname.replace(/^www\./i, "");
  } catch {
    return normalizedUrl
      .replace(/^[a-z]+:\/\//i, "")
      .replace(/^www\./i, "")
      .split(/[/?#]/)[0];
  }
}

export function formatAboutParagraph(
  paragraph: string,
  yearsOfExperience: number
) {
  if (!yearsOfExperience) {
    return paragraph;
  }

  return paragraph.replace("{{yearsOfExperience}}", `${yearsOfExperience}+`);
}
